var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncomeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 35,
  height: 35,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.538 21.564h-6.721c-1.137 0-2.075-1.125-2.075-2.486 0-1.361.938-2.486 2.075-2.486h6.672M7.673 19.227V3.009C7.673 1.629 6.566.5 5.21.5c-1.353 0-2.46 1.129-2.46 2.509s1.107 2.509 2.46 2.509H8.25",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.665 25.45c0-.49.368-.736 1.044-.736.675 0 1.043.184 1.534.553l.553-.614c-.43-.43-.921-.737-1.658-.798V22.81h-.736v1.044c-1.044.122-1.72.736-1.72 1.596 0 1.841 3.254 1.657 3.254 2.823 0 .491-.368.799-1.105.799-.736 0-1.35-.308-1.903-.675l-.552.675c.49.43 1.228.736 1.964.797v1.168h.737V29.87c1.105-.123 1.842-.797 1.842-1.657 0-1.904-3.254-1.719-3.254-2.762",
  fill: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.33 33.307-5.27-5.276a1.834 1.834 0 0 1 0-2.638l5.27-5.276a1.83 1.83 0 0 1 2.635 0l5.27 5.276a1.834 1.834 0 0 1 0 2.638l-5.27 5.276a1.868 1.868 0 0 1-2.635 0z",
  stroke: "#635DF5",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.703 2.563h19.854c1.185 0 2.146.946 2.146 2.111v14.779c0 1.166-.961 2.11-2.146 2.11h-1.61",
  stroke: "#252525"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.797 5.574h19.708c1.21 0 2.19.995 2.19 2.222v15.556c0 1.227-.98 2.222-2.19 2.222H18.2",
  stroke: "#252525"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncomeIcon);
export default ForwardRef;